<script>

    import { createEventDispatcher } from 'svelte';
    import FileUploader from './FileUploader.svelte';

    export let items = [];

    export let accept;
    export let maxSize;
    export let maxFiles;
    export let url;
    export let validation;
    export let deleteConfirmation = 'Are you sure you want to remove this file?';

    const dispatcher = createEventDispatcher();


    const removeItem = (item) => {
        if (deleteConfirmation && !confirm(deleteConfirmation)) return;
        items = items.filter(el => el.id != item.id);
    }


    </script>

    {#if !maxFiles || items.length < maxFiles}
    <div class="mb-3">
    <FileUploader title="Add file(s)" {accept} {maxSize} {maxFiles} {url} {validation} uploaded_files={items.length} on:fileUploaded={(e) => { items = [...items, e.detail] }} />
    </div>
    {/if}


    <div class="filelist">
        {#each items as item (item.id)}
        <div class="filelist-item d-flex align-items-center gap-2 my-3">
            <i class="color4 fal fa-2x fa-{item.icon}"></i>
            {item.name}
            <small class="color4">{item.size}</small>
            <a href="{item.url}" title="Open" target="_blank"><i class="fal fa-external-link"></i></a>
            <button type="button" title="Remove" class="btn btn-link text-danger" on:click={() => removeItem(item)}><i class="fal fa-trash"></i></button>
        </div>
        {/each}
    </div>

<style>
.color4 {
    color: #66c4dc;
}
</style>
